import PropTypes from "prop-types";
import React, { createContext, useMemo } from "react";

// project imports
import config from "config";
import { useLocalStorage } from "hooks/useLocalStorage";

// ==============================|| CONFIG CONTEXT ||============================== //

export const ConfigContext = createContext(undefined);

// ==============================|| CONFIG PROVIDER ||============================== //

export function ConfigProvider({ children }) {
  // Create a hardcoded config that always uses theme1
  const hardcodedConfig = {
    ...config,
    presetColor: "theme1",
    i18n: "en",
  };

  const { state, setState, setField, resetState } = useLocalStorage(
    "berry-config-vite-ts",
    hardcodedConfig,
  );

  // Force i18n to always be 'en' and presetColor to always be 'theme1'
  const modifiedSetField = (field, value) => {
    if (field === "i18n" || field === "presetColor") {
      // Ignore any attempts to change i18n or presetColor, keep them as 'en' and 'theme1'
      return;
    }
    setField(field, value);
  };

  // Always use theme1 and en, regardless of localStorage
  const modifiedState = {
    ...state,
    i18n: "en",
    presetColor: "theme1",
  };

  const memoizedValue = useMemo(
    () => ({
      state: modifiedState,
      setState,
      setField: modifiedSetField,
      resetState,
    }),
    [modifiedState, setField, setState, resetState],
  );

  return (
    <ConfigContext.Provider value={memoizedValue}>
      {children}
    </ConfigContext.Provider>
  );
}

ConfigProvider.propTypes = { children: PropTypes.node };
